import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles/";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
const useStyles = makeStyles({

  categoryCard: {
    padding:10,
    cursor:"pointer",
    backgroundColor: '#fafafa',
    paddingVertical: 10,
    paddingHorizontal: 6,
    borderRadius: 10,
    marginTop: 15,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    borderStyle: "solid",
    opacity: 1,
    borderWidth: 0.35,
  },
  storeImage: {
    width: 40,
    height: 40,
    borderRadius: 100,
    marginStart: 15
  },

  checkbox: {
    backgroundColor: '#fafafa',
    paddingVertical: 10,
    paddingHorizontal: 6,
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center',
    borderStyle: "solid",
    marginEnd: 10,
    opacity: 1,
    borderWidth: 1,
  },
});
 const CategoryCard = ({index, title ,onSelect }) => {
    const { t, i18n } = useTranslation();
    const styles = useStyles();
    const theme = useTheme();
    const handlePress = ()=>{
      if(onSelect){
        onSelect();
      }
    }
    return <Grid item key={index} xs={12} sm={4} md={4}>
      <div
      onClick={handlePress}
      className={styles.categoryCard}
      style={{ borderColor: theme.light.primary,}}
    >
        <Typography
          style={{ fontSize: 18, fontWeight: '500' ,textAlign:"center", alignSelf:"center"}}
        >{`${title}`}</Typography>
      
    </div>
    </Grid>;
  }
  
  export default CategoryCard;